import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "首页", -1)
const _hoisted_2 = {
  key: 0,
  class: "icons-font",
  "aria-hidden": "true"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-homeUnselect" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "icons-font",
  "aria-hidden": "true"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-homeSelect-copy" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "我的", -1)
const _hoisted_9 = {
  key: 0,
  class: "icons-font",
  "aria-hidden": "true"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-myUnselect" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "icons-font",
  "aria-hidden": "true"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-mySelect-copy" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_tabbar, {
      modelValue: _ctx.active,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.active = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          to: "/",
          icon: "wap-home-o"
        }, {
          icon: _withCtx(() => [
            (_ctx.active != 0)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.active == 0)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          to: "/user",
          icon: "friends-o"
        }, {
          icon: _withCtx(() => [
            (_ctx.active != 1)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.active == 1)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}